import axios from "axios";
import Cookies from "js-cookie";
import React, { useState, ChangeEvent, useEffect } from "react";
import submit from "../../assets/submit.gif";

interface FormData {
  feedback_answers: { ques: string; ans: string[] }[];
}

interface FeedbackSurveyProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const FeedbackSurvey: React.FC<FeedbackSurveyProps> = ({ show, setShow }) => {
  const [step, setStep] = useState(1);
  const [feedbackSuccess, setFeedBackSuccess] = useState(false);

  const [formData, setFormData] = useState<FormData>({
    feedback_answers: [
      { ques: "Found Your Perfect Lens Match?", ans: [] },
      {
        ques: "Which Xclusive membership Perk do you love the most?",
        ans: [],
      },
      { ques: "Your thoughts on your shopping experience?", ans: [] },
    ],
  });

  const [isRadioChecked, setIsRadioChecked] = useState(false);

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
    setIsRadioChecked(false)
  };

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleRadioChange = (stepIndex: number, answer: string) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.feedback_answers[stepIndex].ans = [answer];
      return updatedData;
    });
  };

  const handleTextAreaChange = (stepIndex: number, answer: string) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      updatedData.feedback_answers[stepIndex].ans = [answer];
      return updatedData;
    });
  };

  const handleRadioInputChange = (
    event: ChangeEvent<HTMLInputElement>,
    stepIndex: number
  ) => {
    const answer = event.target.value;
    handleRadioChange(stepIndex, answer);

    setIsRadioChecked(true);
  };

  





  const handleTextAreaInputChange = (
    event: ChangeEvent<HTMLTextAreaElement>,
    stepIndex: number
  ) => {
    const answer = event.target.value;
    handleTextAreaChange(stepIndex, answer);
  };

  const handleSubmit = () => {
    // Handle form submission with formData
    console.log("Form Data:", formData);
    submitFeedBack();
    // You can add logic to submit the data to your backend or perform further actions.
  };

  // submit review
  const [feedback, setFeedback] = useState();

  const submitFeedBack = async () => {
    // const bearerToken = "26d7f5a909d3da9f14958b8436eca2c8";
    const bearerToken = Cookies.get('cookieName');
    const url = `https://backend.aqualens.in/app/v1/post-checkout/survey/feedback/answers`;

    try {
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      });

      setFeedback(response.data);
      // console.log(response.data, "dfghjkl"); // Handle the response data here
    } catch (error) {
      console.error(error); // Handle any errors that occur during the request
    }
  };

//   console.log(feedback);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Add 'animate' class to trigger the animation after the component has mounted
    setAnimate(true);
  }, []);



  

  return (
    <>
      <div className="surveyFormWrapper" 
      style={{ backgroundColor: feedbackSuccess ? '#3D6AAE' : 'white',
       display: feedbackSuccess ? 'flex' : 'initial',
       alignItems: feedbackSuccess ? 'center' : 'initial',
        justifyContent: feedbackSuccess ? 'center' : 'initial',
        zIndex: feedbackSuccess ? '999999' : '99999' }}>
        {feedbackSuccess === false && (
          <div className="surveyFormWrapperContent">
            <div className="surveyProgressBar">
              <div onClick={() => setShow(false)}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z"
                    fill="#4F4F4F"
                  ></path>
                </svg>
              </div>
              <div className="progress-bar-container">
                <div className={`progress-bar step-${step}`} />
              </div>
            </div>
            {step === 1 && (
              <div className="surveyQuestions">
                <h2>Question 1</h2>
                <p>Found Your Perfect Lens Match?</p>
                <div className="survayAnswersWrapper">
                  <label className="survayAnswers1">
                    <input
                      type="radio"
                      value="Yes"
                      checked={formData.feedback_answers[0].ans.includes("Yes")}
                      onChange={(e) => handleRadioInputChange(e, 0)}
                    />
                    Yes
                  </label>
                  <label className="survayAnswers1">
                    <input
                      type="radio"
                      value="No"
                      checked={formData.feedback_answers[0].ans.includes("No")}
                      onChange={(e) => handleRadioInputChange(e, 0)}
                    />
                    No
                  </label>
                </div>
                <div className="progressBtn">
                  <button onClick={handleNext}  disabled={!isRadioChecked}>
                    <span>Next →</span>
                  </button>
                </div>
              </div>
            )}
            {step === 2 && (
              <div className="surveyQuestions">
                <h2>Question 2</h2>
                <p>Which Xclusive membership Perk do you love the most?</p>
                <div className="survayAnswersWrapper2">
                  <label className="survayAnswers2">
                    <input
                      type="radio"
                      value="One Free Lens on every 3 Orders"
                      checked={formData.feedback_answers[1].ans.includes(
                        "One Free Lens on every 3 Orders"
                      )}
                      onChange={(e) => handleRadioInputChange(e, 1)}
                    />
                    One Free Lens on every 3 Orders
                  </label>
                  <label className="survayAnswers2">
                    <input
                      type="radio"
                      value="Free Solution on every clear monthly lens"
                      checked={formData.feedback_answers[1].ans.includes(
                        "Free Solution on every clear monthly lens"
                      )}
                      onChange={(e) => handleRadioInputChange(e, 1)}
                    />
                    Free Solution on every clear monthly lens
                  </label>
                  <label className="survayAnswers2">
                    <input
                      type="radio"
                      value="Free doorstep Delivery"
                      checked={formData.feedback_answers[1].ans.includes(
                        "Free doorstep Delivery"
                      )}
                      onChange={(e) => handleRadioInputChange(e, 1)}
                    />
                    Free doorstep Delivery
                  </label>
                  <label className="survayAnswers2">
                    <input
                      type="radio"
                      value="Chance to get Featured on our Insta Page"
                      checked={formData.feedback_answers[1].ans.includes(
                        "Chance to get Featured on our Insta Page"
                      )}
                      onChange={(e) => handleRadioInputChange(e, 1)}
                    />
                    Chance to get Featured on our Insta Page
                  </label>
                </div>
                <div className="progressBtn">
                  {/* <button onClick={handlePrevious}>Previous</button> */}
                  <button onClick={handleNext}  disabled={!isRadioChecked}>Next →</button>
                </div>
              </div>
            )}
            {step === 3 && (
              <div className="surveyQuestions">
                <h2>Question 3</h2>
                <p>Your thoughts on your shopping experience?</p>
                <div className="survayAnswersWrapper3">
                  <p>
                    Please let us know if you have any comments or suggestions
                  </p>
                  <textarea
                    className="survayAnswers3"
                    value={formData.feedback_answers[2].ans[0] || ""}
                    onChange={(e) => handleTextAreaInputChange(e, 2)}
                  />
                </div>
                <div className="progressBtn">
                  {/* <button onClick={handlePrevious}>Previous</button> */}
                  <button
                    onClick={() => {
                      setFeedBackSuccess(true);
                      handleSubmit();
                    }}
                  >
                    Submit →
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        { feedbackSuccess && (
        //   <div className="submittedFeedBack">
        <>
            
            <div className={`submittedFeedback ${animate ? 'animate' : ''}`}>
                <div style={{display: 'flex',
                            justifyContent: 'center'}}>
                     <img src={submit} alt="" />

                </div>
            <p>Thank you for your feedback</p>
            <a href="https://aqualens.in/pages/my-orders">Continue to my orders</a>
           
          </div>
          </>
        )}
      </div>
    </>
  );
};

export default FeedbackSurvey;

// import React, { useState } from 'react';

// const FeedbackSurvey: React.FC = () => {
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState({
//     step1: { answer: '' },
//     step2: { answer: '' },
//     step3: { answer: '' },
//   });

//   const handleNext = () => {
//     setStep((prevStep) => prevStep + 1);
//   };

//   const handlePrevious = () => {
//     setStep((prevStep) => prevStep - 1);
//   };

//   const handleRadioChange = (stepKey: string, answer: string) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [stepKey]: { answer },
//     }));
//   };

//   const handleTextAreaChange = (stepKey: string, answer: string) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [stepKey]: { answer },
//     }));
//   };

//   const handleSubmit = () => {
//     // Handle form submission with formData
//     console.log('Form Data:', formData);
//     // You can add logic to submit the data to your backend or perform further actions.
//   };

//   return (
//     <div>
//       <div className="progress-bar-container">
//         <div className={`progress-bar step-${step}`} />
//       </div>
//       {step === 1 && (
//         <div>
//           <h2>Step 1: Yes or No?</h2>
//           <label>
//             <input
//               type="radio"
//               value="Yes"
//               checked={formData.step1.answer === 'Yes'}
//               onChange={() => handleRadioChange('step1', 'Yes')}
//             />
//             Yes
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="No"
//               checked={formData.step1.answer === 'No'}
//               onChange={() => handleRadioChange('step1', 'No')}
//             />
//             No
//           </label>
//           <button onClick={handleNext}>Next</button>
//         </div>
//       )}
//       {step === 2 && (
//         <div>
//           <h2>Step 2: Choose an option</h2>
//           <label>
//             <input
//               type="radio"
//               value="Convenient buying process"
//               checked={formData.step2.answer === 'Convenient buying process'}
//               onChange={() =>
//                 handleRadioChange('step2', 'Convenient buying process')
//               }
//             />
//             Convenient buying process
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Communication was clear and complete"
//               checked={
//                 formData.step2.answer === 'Communication was clear and complete'
//               }
//               onChange={() =>
//                 handleRadioChange('step2', 'Communication was clear and complete')
//               }
//             />
//             Communication was clear and complete
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Customer Support Experience"
//               checked={formData.step2.answer === 'Customer Support Experience'}
//               onChange={() =>
//                 handleRadioChange('step2', 'Customer Support Experience')
//               }
//             />
//             Customer Support Experience
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Other"
//               checked={formData.step2.answer === 'Other'}
//               onChange={() => handleRadioChange('step2', 'Other')}
//             />
//             Other
//           </label>
//           <button onClick={handlePrevious}>Previous</button>
//           <button onClick={handleNext}>Next</button>
//         </div>
//       )}
//       {step === 3 && (
//         <div>
//           <h2>Step 3: Enter text</h2>
//           <textarea
//             value={formData.step3.answer}
//             onChange={(e) => handleTextAreaChange('step3', e.target.value)}
//           />
//           <button onClick={handlePrevious}>Previous</button>
//           <button onClick={handleSubmit}>Submit</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FeedbackSurvey;

// import React, { useState, ChangeEvent } from 'react';

// const FeedbackSurvey: React.FC = () => {
//   const [step, setStep] = useState(1);
//   const [formData, setFormData] = useState({
//     feedback_answers: [
//       { ques: 'Did you win anything upon logging in?', ans: [] as string[] },
//       {
//         ques: 'Did you receive additional discounts using coupons?',
//         ans: [] as string[],
//       },
//       { ques: 'Have you tried the Xclusive membership?', ans: [] as string[] },
//     ],
//   });

//   const handleNext = () => {
//     setStep((prevStep) => prevStep + 1);
//   };

//   const handlePrevious = () => {
//     setStep((prevStep) => prevStep - 1);
//   };

//   const handleRadioChange = (stepKey: string, answer: string[]) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [stepKey]: { ans: answer },
//     }));
//   };

//   const handleTextAreaChange = (stepKey: string, answer: string[]) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [stepKey]: { ans: answer },
//     }));
//   };

//   const handleRadioInputChange = (
//     event: ChangeEvent<HTMLInputElement>,
//     stepKey: string
//   ) => {
//     const answer = event.target.value;
//     handleRadioChange(stepKey, [answer]);
//   };

//   const handleTextAreaInputChange = (
//     event: ChangeEvent<HTMLTextAreaElement>,
//     stepKey: string
//   ) => {
//     const answer = event.target.value;
//     handleTextAreaChange(stepKey, [answer]);
//   };

//   const handleSubmit = () => {
//     // Handle form submission with formData
//     console.log('Form Data:', formData);
//     // You can add logic to submit the data to your backend or perform further actions.
//   };

//   return (
//     <div>
//       <div className="progress-bar-container">
//         <div className={`progress-bar step-${step}`} />
//       </div>
//       {step === 1 && (
//         <div>
//           <h2>Step 1: Yes or No?</h2>
//           <label>
//             <input
//               type="radio"
//               value="Yes"
//               checked={formData.feedback_answers[0].ans.includes('Yes')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             Yes
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="No"
//               checked={formData.feedback_answers[0].ans.includes('No')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             No
//           </label>
//           <button onClick={handleNext}>Next</button>
//         </div>
//       )}
//       {step === 2 && (
//         <div>
//           <h2>Step 2: Choose an option</h2>
//           <label>
//             <input
//               type="radio"
//               value="Convenient buying process"
//               checked={formData.feedback_answers[1].ans.includes('Convenient buying process')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             Convenient buying process
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Communication was clear and complete"
//               checked={formData.feedback_answers[1].ans.includes('Communication was clear and complete')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             Communication was clear and complete
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Customer Support Experience"
//               checked={formData.feedback_answers[1].ans.includes('Customer Support Experience')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             Customer Support Experience
//           </label>
//           <label>
//             <input
//               type="radio"
//               value="Other"
//               checked={formData.feedback_answers[1].ans.includes('Other')}
//               onChange={(e) => handleRadioInputChange(e, 'feedback_answers')}
//             />
//             Other
//           </label>
//           <button onClick={handlePrevious}>Previous</button>
//           <button onClick={handleNext}>Next</button>
//         </div>
//       )}
//       {step === 3 && (
//         <div>
//           <h2>Step 3: Enter text</h2>
//           <textarea
//             value={formData.feedback_answers[2].ans[0]}
//             onChange={(e) => handleTextAreaInputChange(e, 'feedback_answers')}
//           />
//           <button onClick={handlePrevious}>Previous</button>
//           <button onClick={handleSubmit}>Submit</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FeedbackSurvey;
